module.exports = __webpack_public_path__ + "static/assets/ed839a3be50a57c11f4bf418803a5ed0.png";